<script lang="ts">
  import { toggleHighContrastStore } from '$lib/stores/highContrastTheme.store';

  const year = new Date().getFullYear();
  function switchTheme() {
    toggleHighContrastStore();
  }
</script>

<div class="wrapper px-12 pb-12 bg-blue text-white text-center">
  <!-- Footer -->
  <div class="margins">
    <div class="h-1 pt-12 mx-auto border-b-2 border-gray-50 rounded-sm" />
    <!-- <hr class="w-5/6 bg-white mx-auto my-5" style="height:2px;" /> -->
    <ul
      class="grid xs:grid-cols-1 sm:grid-cols-2 justify-center md:grid-cols-4 md:justify-between text-gray-50"
    >
      <li class="footer-item">
        <a href="/privacy">Privacy Policy &<br />Terms of Use</a>
      </li>
      <li class="footer-item">
        <a rel="external" href="https://info.utheory.com/accessibility-roadmap-b5e1926d7e3a/"
          >Accessibility</a
        >
      </li>
      <li class="footer-item">
        <button on:click={switchTheme}>Use or disable high-contrast theme</button>
      </li>
      <li class="footer-item">
        <a href="mailto:hello@utheory.com">hello@utheory.com</a><br />
        <a href="tel:18668380556">(866) 838-0556</a>
      </li>
    </ul>
  </div>
  <!-- End Footer -->
</div>
<!-- End Closing Tag / uTheory Does it All & Footer -->

<!-- Copyright & TM -->
<div class="text-center text-gray-light mx-auto text-xs mt-4">
  &copy;{year} uTheory, LLP<br />
  uTheory is a registered trademark of uTheory, LLP
</div>

<style lang="postcss">
  /* Note: These are the only weights supported by Roboto - we adapt tailwinds font-__ to them */
  @import 'https://fonts.googleapis.com/css?family=Roboto:400,700,500,300,900,100';

  .footer-item {
    @apply w-36 mx-auto mt-4;
    /* max-width: 180px;
		min-width: 120px; */
  }
</style>
